import { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ChevronDown, LogOut, LayoutDashboard, User, FileText, MessageSquare, LifeBuoy, MapPin } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function UserMenu({ onAfterClick }) {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const onDown = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDown);
    return () => document.removeEventListener("mousedown", onDown);
  }, []);

  if (!user) return null;
  const initial = (user.ad_soyad || "?").charAt(0).toUpperCase();
  const firstName = (user.ad_soyad || "").split(" ")[0] || "Üye";

  const handle = (fn) => () => {
    setOpen(false);
    onAfterClick && onAfterClick();
    fn();
  };

  return (
    <div ref={ref} className="relative">
      <button
        onClick={() => setOpen((o) => !o)}
        className="flex items-center gap-2 rounded-xl bg-white border border-slate-200 hover:border-[#10B981] px-2.5 py-1.5 transition-colors"
        data-testid="user-menu-btn"
      >
        <div className="h-7 w-7 rounded-full bg-emerald-100 text-[#10B981] text-sm font-semibold flex items-center justify-center">
          {initial}
        </div>
        <span className="hidden sm:inline text-sm font-medium text-[#0F172A]">{firstName}</span>
        <ChevronDown className={`h-4 w-4 text-slate-400 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-56 rounded-2xl bg-white border border-slate-100 pak-shadow-lg overflow-hidden z-50" data-testid="user-menu-dropdown">
          <div className="px-4 py-3 border-b border-slate-100">
            <p className="text-sm font-semibold truncate">{user.ad_soyad}</p>
            <p className="text-xs text-slate-500 truncate">{user.email}</p>
          </div>
          <div className="py-1.5">
            <button onClick={handle(() => navigate("/hesabim"))} className="w-full text-left flex items-center gap-2.5 px-4 py-2.5 text-sm text-[#0F172A] hover:bg-slate-50" data-testid="menu-account">
              <User className="h-4 w-4 text-slate-500" /> Hesabım
            </button>
            {user.role === "admin" ? (
              <button onClick={handle(() => navigate("/admin"))} className="w-full text-left flex items-center gap-2.5 px-4 py-2.5 text-sm text-[#0F172A] hover:bg-slate-50" data-testid="menu-admin">
                <LayoutDashboard className="h-4 w-4 text-slate-500" /> Yönetim
              </button>
            ) : user.role === "saglayici" ? (
              <button onClick={handle(() => navigate("/panel"))} className="w-full text-left flex items-center gap-2.5 px-4 py-2.5 text-sm text-[#0F172A] hover:bg-slate-50" data-testid="menu-panel">
                <LayoutDashboard className="h-4 w-4 text-slate-500" /> Panelim
              </button>
            ) : (
              <>
                <button onClick={handle(() => navigate("/taleplerim"))} className="w-full text-left flex items-center gap-2.5 px-4 py-2.5 text-sm text-[#0F172A] hover:bg-slate-50" data-testid="menu-talepler">
                  <FileText className="h-4 w-4 text-slate-500" /> Taleplerim
                </button>
                <button onClick={handle(() => navigate("/adreslerim"))} className="w-full text-left flex items-center gap-2.5 px-4 py-2.5 text-sm text-[#0F172A] hover:bg-slate-50" data-testid="menu-adresler">
                  <MapPin className="h-4 w-4 text-slate-500" /> Kayıtlı Adreslerim
                </button>
                <button onClick={handle(() => navigate("/mesajlarim"))} className="w-full text-left flex items-center gap-2.5 px-4 py-2.5 text-sm text-[#0F172A] hover:bg-slate-50" data-testid="menu-mesajlar">
                  <MessageSquare className="h-4 w-4 text-slate-500" /> Mesajlarım
                </button>
                <button onClick={handle(() => navigate("/destek"))} className="w-full text-left flex items-center gap-2.5 px-4 py-2.5 text-sm text-[#0F172A] hover:bg-slate-50" data-testid="menu-destek">
                  <LifeBuoy className="h-4 w-4 text-slate-500" /> Destek
                </button>
              </>
            )}
          </div>
          <div className="border-t border-slate-100 py-1.5">
            <button onClick={handle(async () => { await logout(); navigate("/"); })} className="w-full text-left flex items-center gap-2.5 px-4 py-2.5 text-sm text-red-600 hover:bg-red-50" data-testid="menu-logout">
              <LogOut className="h-4 w-4" /> Çıkış Yap
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
